import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { Typography, Divider, Paper, Grid, Box, Stack, Tooltip, IconButton, Button, Dialog, DialogActions, DialogTitle, DialogContent, TextField
} from '@mui/material';
import { useSnackbar } from 'notistack';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ReactDataGrid from '@inovua/reactdatagrid-community'
import useConfirm from 'core/hooks/useConfirm';
import '@inovua/reactdatagrid-community/index.css'
import {  deleteLibraryType, getLibraryTypes, saveLibraryType } from 'services/libraries';


const LibraryTypesPage = () => {

  const gridStyle = useMemo(() => ({ minHeight: 480, width: 422 }), []);
  const [libraryTypes, setLibraryTypes] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const confirm = useConfirm();
  const libTypeInputRef = useRef(null);

  const onActionBtnClick = useCallback((e, type, libraryType) => {
    e.preventDefault();
    if(type === 'delete'){
      onLibraryTypeDelete(libraryType);
    }
  }, []);

  const columns = useMemo(() => ([
    { name: 'name', header: 'Library type', width: 320},
    { name: 'actions', header: 'Actions', width: 120, render: ({data}) => {
      return (
        <Stack direction="row" spacing={1}>
          <Box>
            <Tooltip title="Delete" arrow placement="left">
              <IconButton onClick={(e) => onActionBtnClick(e, 'delete', data?.name)}>
                <DeleteForeverIcon color="error" />
              </IconButton>
            </Tooltip>
          </Box>
        </Stack>
      )
    }},
  ]),[onActionBtnClick]);

  useEffect(() => {
    loadLibraryTypes();
  }, []);

  function loadLibraryTypes() {
    getLibraryTypes().then(({response, error}) => {
      if(response){
        setLibraryTypes([...(response || [])].map((ele) => ({name: ele})));
      } else {
        setLibraryTypes([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const onLibraryTypeDelete = (libraryType) => {
    confirm({ title: 'Delete library type?', description: 'Are you sure you want proceed?' })
    .then(() => { 
      _deleteLibraryType(libraryType);
    }).catch((e)=>{})
  }

  const onModalClose = useCallback(
    () => {
      setOpenModal(false);
    },
    [setOpenModal],
  )

  const onSaveBtnClick = (libType) => {
    if(libType){
      addLibraryType(libType);
    }else{
      enqueueSnackbar("Enter library type", {variant: 'error'});
    }
  };

  const onAddBtnClick = () => {
    setOpenModal(true);
  }

  const onlibraryTypeAdded = () => {
    setOpenModal(false);
    loadLibraryTypes();
  }

  function addLibraryType(libraryType) {
    saveLibraryType({libraryType}).then(({response, error}) => {
      if(response){
        enqueueSnackbar((response?.message || 'Library type added successfully'), {variant: 'success'});
        libTypeInputRef.current.value = '';
        onlibraryTypeAdded();
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  function _deleteLibraryType(libraryType) {
    deleteLibraryType({libraryType}).then(({response, error}) => {
      if(response){
        enqueueSnackbar((response?.message || 'Library type deleted successfully'), {variant: 'success'});
        loadLibraryTypes();
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
    {/* <CardContent> */}
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Library Types
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12} >
            <Button variant="contained" sx={{textTransform: 'none'}} onClick={onAddBtnClick}>Add Type</Button>
            <Box component="div" sx={{  mt: 3 ,  maxHeight: 720, width: '100%' }}>
              <ReactDataGrid
                // handle={setGridRef}
                // idProperty="index"
                style={gridStyle}
                // defaultFilterValue={filterValue}
                columns={columns}
                dataSource={libraryTypes}
                rowHeight={null} 
                minRowHeight={50}
              />
            </Box>
          </Grid>
        </Grid>
      </Box> 
      
      <Dialog open={openModal} onClose={onModalClose}>
        <DialogTitle>Add Library Type</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense" 
            id="name"
            label="Library Type"
            type="text" 
            fullWidth
            variant="standard"
            sx={{width: '320px'}}
            inputRef={libTypeInputRef}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onModalClose}>Cancel</Button>
          <Button onClick={() => onSaveBtnClick(libTypeInputRef.current.value)}>Save</Button>
        </DialogActions>
      </Dialog>

    </Paper>
  );
}
 
export default React.memo(LibraryTypesPage);
